import React, { useState } from 'react';
import styled from 'styled-components';
import { BoxedResponsiveStyled } from '../../../style/components/common.styled';

const WrapperStyles = styled.section`
  max-width: 1100px;
  width: 100%;
  display: grid;
  grid-template-columns: 280px 1fr;
  grid-gap: 24px;
  margin: 20px auto;
  min-height: 550px;
  padding: 0 16px;

   @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-gap: 16px;
  }
`;

const MenuStyles = styled(BoxedResponsiveStyled)`
  padding: 16px;
  height: fit-content;
  background: linear-gradient(135deg, rgba(20, 20, 25, 0.7) 0%, rgba(10, 10, 12, 0.9) 100%);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
  
  h3 {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    color: var(--text-muted);
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    padding-bottom: 12px;
    margin-bottom: 14px;
    display: block;
  }

  .category-header {
    font-size: 9.5px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: var(--text-muted);
    margin: 16px 8px 8px 8px;
    opacity: 0.8;
  }
`;

const MenuItemStyles = styled.div`
  cursor: pointer;
  padding: 10px 12px;
  font-size: 13.5px;
  font-weight: 500;
  border-radius: 8px;
  color: var(--text-secondary);
  position: relative;
  margin-bottom: 4px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  gap: 10px;

  &.active {
    color: var(--text-primary);
    background: rgba(99, 102, 241, 0.08);
    border-left: 3px solid var(--color-primary);
    font-weight: 600;
    padding-left: 9px;
    
    .menu-icon {
      opacity: 1;
    }
  }

  &.disabled {
    color: var(--text-muted);
    cursor: default;
    opacity: 0.5;
  }

  .menu-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    opacity: 0.7;
    transition: all 0.2s ease;
    width: 18px;
    height: 18px;
  }

  .sub {
    font-size: 10px;
    margin-left: auto;
    font-weight: 400;
    color: var(--color-info);
  }

  &:hover:not(.disabled):not(.active) {
    color: var(--text-primary);
    background: rgba(255, 255, 255, 0.03);
    transform: translateX(2px);

    .menu-icon {
      opacity: 1;
    }
  }
`;

const ContentStyles = styled(BoxedResponsiveStyled)`
  padding: 24px;
  background: linear-gradient(135deg, rgba(20, 20, 25, 0.5) 0%, rgba(10, 10, 12, 0.7) 100%);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
  min-height: 500px;
`;

const ContentItemStyles = styled.div`

`;

const MenuSettingsComponent = ({ title, menu, content }) => {

    const [contentIndex, setContentIndex] = useState(0);

    return (
        <WrapperStyles>
            <MenuStyles>
                <h3>{ title }</h3>
                { menu.map((mItem, idx) => {
                    let classes = '';
                    if (idx === contentIndex) {
                        classes += 'active ';
                    }

                    if (mItem.disabled) {
                        classes += 'disabled ';
                    }

                    return (
                        <React.Fragment key={ 'Pzxd' + idx }>
                            { mItem.categoryHeader && (
                                <div className="category-header">{ mItem.categoryHeader }</div>
                            ) }
                            <MenuItemStyles
                                onClick={ () => {
                                    if (!mItem.disabled) {
                                        setContentIndex(idx);
                                    }
                                } }
                                className={ classes }
                            >
                                { mItem.icon ? (
                                    <span className="menu-icon cion">{ mItem.icon }</span>
                                ) : null }
                                <span>{ mItem.title }</span>
                                { mItem.subTitle
                                    ? <span
                                        className="sub">{ mItem.subTitle }</span>
                                    : null }
                            </MenuItemStyles>
                        </React.Fragment>
                    );
                }) }
            </MenuStyles>
            <ContentStyles>
                <ContentItemStyles>
                    { content[contentIndex] }
                </ContentItemStyles>
            </ContentStyles>
        </WrapperStyles>
    );
};

export default MenuSettingsComponent;
